import { call, put } from "redux-saga/effects";
import { SupportFAQResponse, TransactionsResponse } from "reduxStore/dataTypes";
import {
  supportFAQFailure,
  supportFAQSuccess,
  supportFAQRequest,
} from "../reducers/faqReducer";
import { fetchSupportFAQ, fetchTransactions } from "services/apiService";

function* supportFAQSaga(): Generator<any, void, SupportFAQResponse | any> {
  try {
    yield put(supportFAQRequest());
    let response = yield call(fetchSupportFAQ);
    yield put(supportFAQSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(supportFAQFailure(error.response));
    } else {
      yield put(supportFAQFailure(error.message));
    }
  }
}

export default supportFAQSaga;
